import { observer } from 'mobx-react'
import React from 'react'
import i18n from 'i18next'

import InfoAccordion from '../../InfoAccordion'

const RapidSurveyAccordion = (props) => {
    const { store } = props
    const { survey } = store
    const textPrefix = 'surveyBuilder.rapidSurvey.accordion'
    const maxCount = 3
    const customQuestionOids = [6, 7] // 7 is legacy
    const customQuestionsCount = survey.pages
        .filter((pq) => pq.pageType === 'ST')
        .flatMap((pq) => pq.questions)
        .reduce((count, q) => count + (customQuestionOids.includes(q.question?.metadata.oid)), 0)
    const remainingQuestions = Math.max(0, maxCount - customQuestionsCount)
    store.survey.rapidSurveyRemainingQuestions = remainingQuestions

    const countText = textPrefix + (remainingQuestions === 1 ? '.desc.oneRemaining' : '.desc.manyRemaining')

    return (
        <div className="rapid-survey-limitation-acc">
            <InfoAccordion
                title={i18n.t(`${textPrefix}.title`)}
                hideChevron
                show
            >
                <p>{i18n.t(`${textPrefix}.desc`)}</p>
                <div className="question-step-count-container">
                    <div className={`${customQuestionsCount > 0 ? 'filled' : ''}`} />
                    <div className={`${customQuestionsCount > 1 ? 'filled' : ''}`} />
                    <div className={`${customQuestionsCount > 2 ? 'filled' : ''}`} />
                </div>
                <b className>{`${remainingQuestions} ${i18n.t(countText)}`}</b>
            </InfoAccordion>
        </div>
    )
}

export default observer(RapidSurveyAccordion)
